import React, { useCallback, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";

import { Button } from "antd";
import moment from "moment";

import summaryApi from "../../apis/Summary.api";

// const convertCategory = (item) => {
//     if (item?.category_type === "ingredient") {
//         return `[성분별] ${item.category_name}`
//     } else if (item?.category_type === "function") {
//         return `[고민별] ${item.category_name}`
//     } else if (item?.category_type === "combination") {
//         return `[조합별] ${item.category_name}`
//     } else if (item?.category_type === "community") {
//         return `[소통] ${item.title}`
//     } else {
//         return ""
//     }
// }
const AnalysisChart = ({ mediaResult, item, type }) => {
	const user = useSelector((state) => state.auth.user);
	const [dataList, setDataList] = useState([]);
	const [dateType, setDateType] = useState({
		key: 0,
		type: "daily",
		pageSize: 30,
		pageType: "month",
	});

	const [labels, setLabels] = useState([]);

	const options = {
		responsive: true,
		// aspectRatio: 0.1,
		maintainAspectRatio: false,
		legend: {
			position: "top",
			align: "center",
		},
		scales: {
			yAxes: [
				{
					ticks: {
						beginAtZero: true,
					},
				},
			],
		},
	};

	const data = {
		labels: labels,
		datasets:
			type === "contents"
				? [
						{
							label: "조회수",
							data: dataList?.map(
								(item) =>
									Math.ceil(
										item?.view_num * (5 + (item?.content_id % 10) / 10)
									) ?? 0
							),
							borderColor: "rgb(255, 99, 132)",
							backgroundColor: "rgba(255, 99, 132, 0.1)",
							// backgroundColor: 'white',
							borderWidth: 2,
						},
						{
							label: "댓글",
							data: dataList?.map((item) => item?.comment_num ?? 0),
							borderColor: "rgb(53, 162, 235)",
							backgroundColor: "rgba(53, 162, 235, 0.1)",
							borderWidth: 2,
						},
						{
							label: "좋아요",
							data: dataList?.map((item) => item?.like_num ?? 0),
							borderColor: "rgba(75, 192, 192)",
							backgroundColor: "rgba(75, 192, 192, 0.1)",
							borderWidth: 2,
						},
				  ]
				: [
						{
							label: "조회수",
							data: dataList?.map((item) => item?.view_num ?? 0),
							borderColor: "rgb(255, 99, 132)",
							backgroundColor: "rgba(255, 99, 132, 0.1)",
							borderWidth: 2,
						},
						{
							label: "댓글",
							data: dataList?.map((item) => item?.comment_num ?? 0),
							borderColor: "rgb(53, 162, 235)",
							backgroundColor: "rgba(53, 162, 235, 0.1)",
							borderWidth: 2,
						},
				  ],
	};

	useEffect(() => {
		if (user?.id && item?.id) {
			getCategoryPeriod();
		}
	}, [user, item, dateType]);

	const getCategoryPeriod = useCallback(async () => {
		const param = {
			offset: 0,
			pageSize: dateType.pageSize,
			userId:
				user?.role === "super_admin"
					? item?.influencer_id
					: user?.role === "level_1"
					? user?.id
					: user?.partners_id,
			// userId:
			// 	user?.role === "level_1" || user?.role === "super_admin"
			// 		? user?.id
			// 		: user?.partners_id,
			id: item?.id,
			categoryType: item?.category_type,
			dateType: dateType.key,
		};
		const res = await summaryApi.readAnalysisSummaryPeriod(param);
		if (res.code === 200) {
			let list = res.result;
			if (list?.length) {
				list = list.reverse();
				setDataList(list);
				if (dateType.key === 0) {
					setLabels(
						list.map((item) =>
							moment(
								`${item.year}-${item.month}-${item.date}`,
								"YYYY-MM-DD"
							)?.format("M월 D일")
						)
					);
				} else if (dateType.key === 1) {
					setLabels(
						list.map((item, idx) => {
							let startDate = moment(
								`${item.year}-${item.month}-${item.date}`,
								"YYYY-MM-DD"
							);
							let endDate = moment(
								`${item.year}-${item.month}-${item.date}`,
								"YYYY-MM-DD"
							).add("6", "days");
							let nextStartDate = moment(
								`${list[idx + 1]?.year}-${list[idx + 1]?.month}-${
									list[idx + 1]?.date
								}`,
								"YYYY-MM-DD"
							);
							if (startDate.format("M") !== endDate.format("M")) {
								endDate = startDate.endOf("months");
							} else if (
								list[idx + 1]?.year &&
								endDate.add(1, "days").format("D") !==
									nextStartDate?.format("D")
							) {
								endDate = nextStartDate;
							}
							return `${startDate?.format("M월 D일")} ~ ${endDate?.format(
								"M월 D일"
							)}`;
						})
					);
				} else {
					setLabels(
						list.map((item) =>
							moment(`${item.year}-${item.month}`, "YYYY-MM")?.format("M월")
						)
					);
				}
			} else {
				setDataList([]);
				setLabels([]);
			}
		}
	}, [item, dateType]);

	const handleDateType = (e) => {
		const { id } = e.currentTarget;
		if (id === "daily") {
			setDateType({
				...dateType,
				key: 0,
				type: "daily",
				// pageSize: 30,
			});
		} else if (id === "weekly") {
			setDateType({
				...dateType,
				key: 1,
				type: "weekly",
				// pageSize: 24
			});
		} else if (id === "monthly") {
			setDateType({
				...dateType,
				key: 2,
				type: "monthly",
				// pageSize: 12
			});
		}
	};

	const handleDatePageSize = (e) => {
		const { id } = e.currentTarget;
		if (id === "month") {
			setDateType({
				...dateType,
				pageSize: dateType.key === 0 ? 30 : dateType.key === 1 ? 12 : 12,
				pageType: id,
			});
		} else if (id === "2-weeks") {
			setDateType({
				...dateType,
				pageSize: dateType.key === 0 ? 14 : dateType.key === 1 ? 8 : 6,
				pageType: id,
			});
		} else if (id === "1-week") {
			setDateType({
				...dateType,
				pageSize: dateType.key === 0 ? 7 : dateType.key === 1 ? 4 : 3,
				pageType: id,
			});
		}
	};

	return (
		<div className={`analysis-chart-div${mediaResult ? " mobile" : ""}`}>
			{!!setDataList?.length && (
				<>
					<div className={`summary-button-total-group`}>
						<div className={`summary-button-group`}>
							<Button
								className={`${dateType.type === "daily" ? "black" : ""}`}
								id={"daily"}
								onClick={handleDateType}
							>
								일
							</Button>
							<Button
								className={`${dateType.type === "weekly" ? "black" : ""}`}
								id={"weekly"}
								onClick={handleDateType}
							>
								주
							</Button>
							{/*<Button*/}
							{/*    className={`${dateType.type === "monthly" ? "black" : ""}`}*/}
							{/*    id={"monthly"}*/}
							{/*    onClick={handleDateType}*/}
							{/*>*/}
							{/*    월*/}
							{/*</Button>*/}
						</div>

						<div className={`summary-button-group summary-page-size`}>
							<Button
								className={`${dateType.pageType === "month" ? "black" : ""}`}
								id={"month"}
								onClick={handleDatePageSize}
							>
								{dateType.key === 0
									? "30일"
									: dateType.key === 1
									? "12주"
									: "12개월"}
							</Button>
							<Button
								className={`${dateType.pageType === "2-weeks" ? "black" : ""}`}
								id={"2-weeks"}
								onClick={handleDatePageSize}
							>
								{dateType.key === 0
									? "14일"
									: dateType.key === 1
									? "8주"
									: "6개월"}
							</Button>
							<Button
								className={`${dateType.pageType === "1-week" ? "black" : ""}`}
								id={"1-week"}
								onClick={handleDatePageSize}
							>
								{dateType.key === 0
									? "7일"
									: dateType.key === 1
									? "4주"
									: "3개월"}
							</Button>
						</div>
					</div>

					<div
						style={{
							position: "relative",
							width: "100%",
							height: "40vh",
						}}
					>
						<Line options={options} data={data} />
					</div>
				</>
			)}
		</div>
	);
};

export default AnalysisChart;
